import React from "react";

const services = [
  {
    title: "Ecommerce Website Development (Shopify, Magento, WooCommerce)",
    description:
      "We build ecommerce stores designed to convert. From custom Shopify themes to Magento and WooCommerce integrations, we ensure speed, security, and scalability with continuous performance audits.",
  },
  {
    title: "Custom Website Development",
    description:
      "Tailored websites engineered to your exact business needs, built using React, Laravel, and modern frameworks. From local service providers to global enterprises, we deliver solutions backed by AI-powered testing and quality assurance.",
  },
  {
    title: "Shopify Plus Development",
    description:
      "As a certified Shopify Partner, we provide complete Shopify Plus services including theme customization, store setup, custom app integrations, performance audits, and ongoing support focused on maximizing sales.",
  },
  {
    title: "Platform Migration Services",
    description:
      "Seamlessly move your website or online store from platforms like Magento, WooCommerce, BigCommerce, or custom CMS to Shopify Plus or a modern framework. We handle data migration, product catalogs, customer accounts, and order history while preserving SEO rankings and ensuring zero downtime.",
  },
  {
    title: "Ongoing Support & Maintenance",
    description:
      "Our job doesn't end at launch. We offer proactive monitoring, security patches, speed optimization, and emergency support to ensure your site stays secure and performs at its best.",
  },
];

const Section4 = () => {
  return (
    <div className="w-full bg-white py-[30px] md:py-[50px]">
      <div className="w-[90%] md:w-[85%] mx-auto">

        {/* Heading */}
        <h2
          className="text-center leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-[#151515] font-bold mb-10"
        >             Our Web Development Services in New York
        </h2>

        {/* Cards Grid Same as Section 14 */}
        <div className="flex justify-center flex-wrap gap-[25px] w-[85%] mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${index % 2 === 0
                ? "bg-[#E42E35] text-white"
                : "bg-[#f5f5f5] text-[#373737]"
                } w-[90%] sm:w-[46%] xl:w-[30%] p-[4%] md:p-[2%] rounded-2xl shadow-md`}
            >
              <h3 className="text-[20px] md:text-[22px] font-bold mb-3 leading-[28px]">
                {service.title}
              </h3>

              <p className="text-[13px] md:text-[14px] leading-[22px]">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* Divider same as Section 14 */}
        <div className="line mb-[55px] mt-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      </div>
    </div>
  );
};

export default Section4;
